/* Parent Hub guides (pn-article): reading progress, contents panel (desktop), section bar (phones),
   smooth jumps to sections and sources, the sources list on phones, and the dates in "How this guide was written".
   Loaded once by sections/ea-article-body.liquid. */
(function () {
  'use strict';

  var doc = document;
  var win = window;
  var DESK = 990;
  var PHONE = 750;
  var reduce = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function q(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  var S = null;        // page state, rebuilt by collect()
  var ticking = false;
  var headerEls = [];

  /* ---------------------------------------------------------------- the site header (sticky) */
  function findHeader() {
    headerEls = [];
    var root = doc.getElementById('header-group') || q('.shopify-section-group-header-group');
    if (!root) return;
    var list = [root];
    var walk = function (el, depth) {
      if (depth > 3) return;
      for (var i = 0; i < el.children.length; i++) {
        var c = el.children[i];
        if (c.tagName === 'SCRIPT' || c.tagName === 'STYLE') continue;
        list.push(c);
        walk(c, depth + 1);
      }
    };
    walk(root, 0);
    var ok = function (el) { return el.offsetHeight > 20 && el.offsetHeight < 260; };
    list.forEach(function (el) {
      var p = win.getComputedStyle(el).position;
      if (p !== 'sticky' && p !== 'fixed') return;
      if (ok(el)) { headerEls.push(el); return; }
      // a zero-height sticky wrapper with the visible header laid over the page (Horizon): use its children
      if (el.offsetHeight <= 20) {
        for (var i = 0; i < el.children.length; i++) { if (ok(el.children[i])) headerEls.push(el.children[i]); }
      }
    });
  }

  function headerBottom() {
    var hb = 0;
    var vw = win.innerWidth;
    for (var i = 0; i < headerEls.length; i++) {
      var r = headerEls[i].getBoundingClientRect();
      if (r.height > 0 && r.width > vw * 0.5 && r.top < 60 && r.bottom > hb) hb = r.bottom;
    }
    return hb > 0 ? hb : 0;
  }

  /* ---------------------------------------------------------------- collect the page */
  function collect() {
    var body = q('[data-pna-body]');
    if (!body) return null;
    var st = {
      body: body,
      head: q('[data-pna-head]'),
      prog: q('[data-pna-progress]'),
      start: q('[data-pna-start]') || body,
      grid: q('.pna-body__grid', body),
      rail: q('[data-pna-rail]', body),
      bar: q('[data-pna-bar]', body),
      mode: {},
      last: {}
    };
    var ends = qa('[data-pna-end]');
    st.end = ends.length ? ends[ends.length - 1] : body;
    st.progFill = st.prog ? st.prog.firstElementChild : null;
    st.read = parseInt(st.head && st.head.getAttribute('data-pna-read'), 10) || 0;
    if (st.bar) {
      st.barIn = q('.pna-bar__inner', st.bar);
      st.barBtn = q('[data-pna-bar-btn]', st.bar);
      st.panel = q('[data-pna-panel]', st.bar);
      st.num = q('[data-pna-num]', st.bar);
      st.label = q('[data-pna-label]', st.bar);
      st.title = q('[data-pna-title]', st.bar);
      st.fill = q('[data-pna-fill]', st.bar);
      st.barTitle0 = st.title ? st.title.textContent : '';
      st.barNum0 = st.num ? st.num.textContent : '';
    }
    st.left = st.rail ? q('[data-pna-left]', st.rail) : null;

    // sections in the contents, in page order, with their rail and bar links
    var ids = [];
    var byId = {};
    qa('[data-pna-link]').forEach(function (a) {
      var id = a.getAttribute('data-pna-link');
      if (!byId[id]) { byId[id] = { id: id, rail: null, bar: null, short: '' }; ids.push(id); }
      if (a.classList.contains('pna-rail__link')) byId[id].rail = a;
      if (a.classList.contains('pna-bar__link')) {
        byId[id].bar = a;
        var t = q('.pna-bar__t', a);
        byId[id].short = t ? t.textContent : a.textContent;
      }
    });
    st.items = [];
    ids.forEach(function (id) {
      var el = doc.getElementById(id);
      if (el) { byId[id].el = el; st.items.push(byId[id]); }
    });
    return st;
  }

  /* ---------------------------------------------------------------- one frame */
  function update() {
    ticking = false;
    if (!S || !doc.body.contains(S.body)) { S = collect(); if (!S) return; }
    var vw = win.innerWidth;
    var vh = win.innerHeight;
    var desk = vw >= DESK;
    var hb = headerBottom();

    // reads
    var sR = S.start.getBoundingClientRect();
    var eR = S.end.getBoundingClientRect();
    var gR = S.grid ? S.grid.getBoundingClientRect() : null;
    var line = hb + (desk ? 40 : 90);
    var railH = S.rail && desk ? S.rail.offsetHeight : 0;
    var barPR = S.bar && !desk ? S.bar.getBoundingClientRect() : null;
    var barH = S.barIn && !desk ? S.barIn.offsetHeight : 0;
    var secTops = S.items.map(function (it) { return it.el.getBoundingClientRect().top; });

    // progress: 0 when the article reaches the reading line, 1 when its end reaches the bottom of the window
    var total = (eR.bottom - sR.top) - (vh - line);
    var pct = total > 0 ? clamp((line - sR.top) / total, 0, 1) : 0;

    // active section: the last heading above a line about a third of the way down the reading area
    var top = hb + (desk ? 0 : barH + 16);
    var aLine = top + (vh - top) * (desk ? 0.3 : 0.25);
    var active = -1;
    for (var i = 0; i < secTops.length; i++) { if (secTops[i] <= aLine) active = i; }

    // writes
    var scrollPad = Math.round(hb + (desk ? 24 : barH + 20)) + 'px';
    if (scrollPad !== S.last.scrollPad) { doc.documentElement.style.setProperty('--pna-scroll', scrollPad); S.last.scrollPad = scrollPad; }

    if (S.prog && S.progFill) {
      S.prog.classList.toggle('is-on', desk && pct > 0 && eR.bottom > hb);
      S.progFill.style.transform = 'scaleX(' + pct.toFixed(4) + ')';
    }

    if (active !== S.last.active) {
      S.items.forEach(function (it, k) {
        if (it.rail) {
          it.rail.classList.toggle('is-active', k === active);
          it.rail.classList.toggle('is-done', k < active);
          if (k === active) it.rail.setAttribute('aria-current', 'true'); else it.rail.removeAttribute('aria-current');
        }
        if (it.bar) it.bar.classList.toggle('is-active', k === active);
      });
      if (S.num && S.title && S.label) {
        if (active >= 0) {
          S.num.textContent = (active + 1) + '/' + S.items.length;
          S.label.textContent = 'Section';
          S.title.textContent = S.items[active].short;
        } else {
          S.num.textContent = S.barNum0;
          S.label.textContent = 'Sections';
          S.title.textContent = S.barTitle0;
        }
      }
      S.last.active = active;
    }

    if (S.fill) S.fill.style.transform = 'scaleX(' + pct.toFixed(4) + ')';

    if (S.left && S.read) {
      var txt = pct <= 0.005 ? S.read + ' min read' : Math.max(1, Math.ceil(S.read * (1 - pct))) + ' min left';
      if (txt !== S.last.left) { S.left.textContent = txt; S.last.left = txt; }
    }

    if (desk) placeRail(hb, sR, eR, gR, railH, vh); else resetRail();
    if (!desk) placeBar(hb, barPR, eR, barH); else resetBar();
  }

  function placeRail(hb, sR, eR, gR, H, vh) {
    if (!S.rail || !gR) return;
    var T = hb + 32;
    var room = vh - T - 16;
    var compact = S.rail.classList.contains('is-compact');
    if (!compact) S.fullRailH = H;
    if (!compact && H > room) {
      S.rail.classList.add('is-compact');
      H = S.rail.offsetHeight;
    } else if (compact && S.fullRailH && S.fullRailH <= room) {
      S.rail.classList.remove('is-compact');
      H = S.rail.offsetHeight;
    }
    var yMin = sR.top;
    var yMax = eR.bottom - H;
    var mode, top, left;
    if (H > room || T <= yMin) { mode = 'abs'; top = yMin - gR.top; left = 0; }
    else if (T < yMax) { mode = 'fixed'; top = T; left = gR.left; }
    else { mode = 'abs'; top = yMax - gR.top; left = 0; }
    top = Math.round(top);
    left = Math.round(left);
    var m = S.mode;
    if (m.rail !== mode || m.railTop !== top || m.railLeft !== left) {
      S.rail.style.position = mode === 'fixed' ? 'fixed' : 'absolute';
      S.rail.style.top = top + 'px';
      S.rail.style.left = left + 'px';
      m.rail = mode; m.railTop = top; m.railLeft = left;
    }
    if (!S.railReady) { S.rail.classList.add('is-ready'); S.railReady = true; }
  }

  function resetRail() {
    if (S.rail && S.mode.rail) {
      S.rail.style.position = ''; S.rail.style.top = ''; S.rail.style.left = '';
      S.rail.classList.remove('is-compact');
      S.mode.rail = null;
    }
  }

  function placeBar(hb, pR, eR, H) {
    if (!S.barIn || !pR) return;
    var T = Math.round(hb + 8);
    var mode = 'static';
    if (pR.top <= T) mode = (eR.bottom - H - 12 > T) ? 'fixed' : 'gone';
    var left = Math.round(pR.left);
    var width = Math.round(pR.width);
    var m = S.mode;
    if (m.bar === mode && m.barTop === T && m.barLeft === left && m.barW === width) return;
    if (mode === 'static') {
      S.barIn.classList.remove('is-fixed', 'is-gone');
      S.barIn.style.top = ''; S.barIn.style.left = ''; S.barIn.style.width = '';
    } else {
      S.barIn.classList.add('is-fixed');
      S.barIn.classList.toggle('is-gone', mode === 'gone');
      S.barIn.style.top = T + 'px';
      S.barIn.style.left = left + 'px';
      S.barIn.style.width = width + 'px';
      if (mode === 'gone') closePanel();
    }
    m.bar = mode; m.barTop = T; m.barLeft = left; m.barW = width;
  }

  function resetBar() {
    if (S.barIn && S.mode.bar) {
      S.barIn.classList.remove('is-fixed', 'is-gone');
      S.barIn.style.top = ''; S.barIn.style.left = ''; S.barIn.style.width = '';
      S.mode.bar = null;
      closePanel();
    }
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    // background tabs pause animation frames, so fall back to a timer there
    if (doc.hidden) setTimeout(update, 60); else win.requestAnimationFrame(update);
  }

  /* ---------------------------------------------------------------- contents panel on phones */
  function openPanel() {
    if (!S || !S.panel) return;
    S.panel.hidden = false;
    S.bar.classList.add('is-open');
    S.barBtn.setAttribute('aria-expanded', 'true');
    var cur = q('.pna-bar__link.is-active', S.panel);
    if (cur && cur.scrollIntoView) { S.panel.scrollTop = Math.max(0, cur.offsetTop - 60); }
  }

  function closePanel() {
    if (!S || !S.panel || S.panel.hidden) return;
    S.panel.hidden = true;
    S.bar.classList.remove('is-open');
    S.barBtn.setAttribute('aria-expanded', 'false');
  }

  /* ---------------------------------------------------------------- jumps */
  function expandSources(box) {
    if (!box) return;
    box.classList.remove('is-collapsed');
    var more = q('[data-pna-srcmore]', box);
    if (more) more.hidden = true;
  }

  var jumpTimer = null;
  function stopJump() { if (jumpTimer) { clearInterval(jumpTimer); jumpTimer = null; } }

  function jumpOffset() {
    var desk = win.innerWidth >= DESK;
    var barH = (!desk && S && S.barIn) ? S.barIn.offsetHeight + 12 : 0;
    return headerBottom() + barH + (desk ? 24 : 12);
  }

  function jumpTo(target, id) {
    var box = target.closest ? target.closest('[data-pna-srcbox]') : null;
    if (box && box.classList.contains('is-collapsed')) expandSources(box);
    var go = function (behavior) {
      var y = target.getBoundingClientRect().top + win.pageYOffset - jumpOffset();
      win.scrollTo({ top: Math.max(0, Math.round(y)), behavior: behavior });
    };
    go(reduce ? 'auto' : 'smooth');
    // images and fonts can still move things while it scrolls: once it settles, correct it (up to 3 times)
    stopJump();
    var lastY = -1, still = 0, fixes = 0, ticks = 0;
    jumpTimer = setInterval(function () {
      var y = win.pageYOffset;
      still = Math.abs(y - lastY) < 1 ? still + 1 : 0;
      lastY = y;
      if (++ticks > 60) { stopJump(); return; }
      if (still < 2) return;
      var d = target.getBoundingClientRect().top - jumpOffset();
      if (Math.abs(d) > 6 && fixes < 3) { fixes++; still = 0; go(reduce ? 'auto' : 'smooth'); }
      else stopJump();
    }, 120);
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    if (target.classList.contains('pna-src__item')) {
      target.classList.add('is-flash');
      setTimeout(function () { target.classList.remove('is-flash'); }, 1600);
    }
    if (target.hasAttribute('tabindex') === false) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
  }

  function onClick(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;

    var gl = t.closest('.pna-gl__term');
    if (gl) {
      var open = gl.getAttribute('aria-expanded') !== 'true';
      closeGloss(gl);
      gl.setAttribute('aria-expanded', open ? 'true' : 'false');
      var pop = doc.getElementById(gl.getAttribute('aria-controls'));
      if (pop) {
        pop.hidden = !open;
        if (open) {
          pop.classList.remove('is-right');
          var r = pop.getBoundingClientRect();
          if (r.right > win.innerWidth - 12) pop.classList.add('is-right');
        }
      }
      return;
    }
    if (!t.closest('.pna-gl__pop')) closeGloss();

    var btn = t.closest('[data-pna-bar-btn]');
    if (btn) {
      if (!S) S = collect();
      if (S && S.panel) { if (S.panel.hidden) openPanel(); else closePanel(); }
      return;
    }

    var more = t.closest('[data-pna-srcmore]');
    if (more) { expandSources(more.closest('[data-pna-srcbox]')); return; }

    var a = t.closest('a[href*="#"]');
    if (a && a.closest('.pna')) {
      var href = a.getAttribute('href');
      var hash = href.slice(href.indexOf('#') + 1);
      var path = href.slice(0, href.indexOf('#'));
      if (!hash || (path && path !== win.location.pathname && a.pathname !== win.location.pathname)) return;
      var target = doc.getElementById(decodeURIComponent(hash));
      if (!target) return;
      e.preventDefault();
      closePanel();
      jumpTo(target, hash);
      return;
    }

    if (S && S.panel && !S.panel.hidden && !t.closest('[data-pna-bar]')) closePanel();
  }

  function onKey(e) {
    if (e.key !== 'Escape') return;
    var g = q('.pna-gl__term[aria-expanded="true"]');
    if (g) { closeGloss(); g.focus(); return; }
    if (S && S.panel && !S.panel.hidden) { closePanel(); if (S.barBtn) S.barBtn.focus(); }
  }

  /* ---------------------------------------------------------------- one-off fills */
  function fillOnce() {
    // sources count on the header chip
    var n = qa('.pna-src__item').length;
    qa('[data-pna-srccount]').forEach(function (el) { if (n) el.textContent = n + (n === 1 ? ' source' : ' sources'); });

    // published and updated dates in "How this guide was written"
    var head = q('[data-pna-head]');
    if (head) {
      var pub = head.getAttribute('data-pna-published');
      var mod = head.getAttribute('data-pna-modified');
      qa('[data-pna-dates]').forEach(function (el) {
        if (pub && mod && pub !== mod) el.textContent = 'First published ' + pub + '. Last updated ' + mod + '.';
        else if (pub) el.textContent = 'Published ' + pub + '.';
      });
    }

    // sources on phones: show the first few, then "Show all"
    qa('[data-pna-srcbox]').forEach(function (box) {
      var extra = qa('.is-extra', box);
      var more = q('[data-pna-srcmore]', box);
      if (!extra.length || !more || box.getAttribute('data-pna-done')) return;
      box.setAttribute('data-pna-done', '1');
      if (win.innerWidth < PHONE && !/^#src-/.test(win.location.hash)) {
        box.classList.add('is-collapsed');
        more.hidden = false;
      }
    });
  }

  /* ---------------------------------------------------------------- glossary: the first mention of each term opens a short explanation */
  function glossary() {
    var data = q('[data-pna-glossary]');
    var body = q('[data-pna-body]');
    if (!data || !body || body.getAttribute('data-pna-gl')) return;
    body.setAttribute('data-pna-gl', '1');
    var terms;
    try { terms = JSON.parse(data.textContent); } catch (e) { return; }
    var paras = qa('.pna-article .pna-p', body);
    terms.forEach(function (t, k) {
      if (!t || !t.term) return;
      var re = new RegExp('\\b(' + t.term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')\\b', 'i');
      for (var i = 0; i < paras.length; i++) {
        var walker = doc.createTreeWalker(paras[i], NodeFilter.SHOW_TEXT, {
          acceptNode: function (n) {
            return n.parentNode.closest('a, sup, button, h2, h3, h4, .pna-gl') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
          }
        });
        var node;
        while ((node = walker.nextNode())) {
          var m = re.exec(node.nodeValue);
          if (!m) continue;
          var after = node.splitText(m.index);
          after.splitText(m[0].length);
          var id = 'pna-gl-' + k;
          var wrap = doc.createElement('span');
          wrap.className = 'pna-gl';
          var btn = doc.createElement('button');
          btn.type = 'button';
          btn.className = 'pna-gl__term';
          btn.setAttribute('aria-expanded', 'false');
          btn.setAttribute('aria-controls', id);
          btn.textContent = after.nodeValue;
          var pop = doc.createElement('span');
          pop.className = 'pna-gl__pop';
          pop.id = id;
          pop.setAttribute('role', 'note');
          pop.hidden = true;
          var n1 = doc.createElement('span'); n1.className = 'pna-gl__name'; n1.textContent = t.term;
          pop.appendChild(n1);
          if (t.say) { var n2 = doc.createElement('span'); n2.className = 'pna-gl__say'; n2.textContent = t.say; pop.appendChild(n2); }
          var n3 = doc.createElement('span'); n3.className = 'pna-gl__text'; n3.textContent = t.text; pop.appendChild(n3);
          wrap.appendChild(btn);
          wrap.appendChild(pop);
          after.parentNode.replaceChild(wrap, after);
          return;
        }
      }
    });
  }

  function closeGloss(except) {
    qa('.pna-gl__term[aria-expanded="true"]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var p = doc.getElementById(b.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
  }

  function onResize() {
    findHeader();
    if (win.innerWidth >= PHONE) qa('[data-pna-srcbox].is-collapsed').forEach(expandSources);
    if (S) S.mode = {};
    schedule();
  }

  function init() {
    S = collect();
    if (!S) return;
    findHeader();
    fillOnce();
    glossary();
    schedule();
  }

  if (!win.__pnaArticle) {
    win.__pnaArticle = true;
    doc.addEventListener('click', onClick);
    doc.addEventListener('keydown', onKey);
    win.addEventListener('wheel', stopJump, { passive: true });
    win.addEventListener('touchstart', stopJump, { passive: true });
    win.addEventListener('scroll', schedule, { passive: true });
    win.addEventListener('resize', onResize);
    win.addEventListener('load', function () { findHeader(); schedule(); });
    doc.addEventListener('visibilitychange', schedule);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(schedule);
    if ('ResizeObserver' in win) new ResizeObserver(schedule).observe(doc.documentElement);
    doc.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
    doc.addEventListener('shopify:section:unload', function () { setTimeout(init, 50); });
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  }
})();